import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
    selector: `[validatePhoneNumber]`
})
export class ValidatePhoneDirective implements AfterViewInit {
    constructor(private elRef: ElementRef) {
    }
    ngAfterViewInit(): void {
        this.elRef.nativeElement.innerText = "Allowed Chars ( + 0-9 - x X )";
        this.elRef.nativeElement.classList.add('validate');
    }
}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/Directives/validate-phone.directive.ts